import { render, staticRenderFns } from "./headern.vue?vue&type=template&id=08c0b5e6&scoped=true"
import script from "./headern.vue?vue&type=script&lang=js"
export * from "./headern.vue?vue&type=script&lang=js"
import style0 from "./headern.vue?vue&type=style&index=0&id=08c0b5e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0b5e6",
  null
  
)

export default component.exports